module.exports = __webpack_public_path__ + "img/lle.be648cf2.jpg";